export default __webpack_public_path__ + "static/media/DC_Oops_B1.6fed8e09.mp3";